// src/fonts/registerRoboto.js
import { RobotoRegular } from "./Roboto-Regular";
import { CaveatRegular } from "./Caveat-Regular";
import { DancingScriptRegular } from "./DancingScript-Regular";
import { DosisLight } from "./Dosis-Light";
import { IndieFlowerRegular } from "./IndieFlower-Regular";
import { LibertinusSerifDisplayRegular } from "./LibertinusSerifDisplay-Regular";
import { QuicksandRegular } from "./Quicksand-Regular";
import { StoryScriptRegular } from "./StoryScript-Regular";
import { ArizoniaRegular } from "./Arizonia-Regular";
import { MountainsofChristmasRegular } from "./MountainsofChristmas-Regular";
import { QwigleyRegular } from "./Qwigley-Regular";
import { NiconneRegular } from "./Niconne-Regular";
import { CalligraffittiRegular } from "./Calligraffitti-Regular";
import { NoricanRegular } from "./Norican-Regular";
import { OoohBabyRegular } from "./OoohBaby-Regular";
import { PlayballRegular } from "./Playball-Regular";
import { CookieRegular } from "./Cookie-Regular";



export function registerRoboto(doc) {
  // Roboto
  //doc.addFileToVFS("Roboto-Regular.ttf", RobotoRegular);
  //doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");

  // Caveat
  doc.addFileToVFS("Caveat-Regular.ttf", CaveatRegular);
  doc.addFont("Caveat-Regular.ttf", "Caveat", "normal");

  // Dancing Script
  doc.addFileToVFS("DancingScript-Regular.ttf", DancingScriptRegular);
  doc.addFont("DancingScript-Regular.ttf", "DancingScript", "normal");

  // Dosis
  doc.addFileToVFS("Dosis-Light.ttf", DosisLight);
  doc.addFont("Dosis-Light.ttf", "Dosis", "normal");

  // Indie Flower
  doc.addFileToVFS("IndieFlower-Regular.ttf", IndieFlowerRegular);
  doc.addFont("IndieFlower-Regular.ttf", "IndieFlower", "normal");

  // Libertinus Serif Display
  doc.addFileToVFS("LibertinusSerifDisplay-Regular.ttf", LibertinusSerifDisplayRegular);
  doc.addFont("LibertinusSerifDisplay-Regular.ttf", "LibertinusSerifDisplay", "normal");

  // Quicksand
  doc.addFileToVFS("Quicksand-Regular.ttf", QuicksandRegular);
  doc.addFont("Quicksand-Regular.ttf", "Quicksand", "normal");

  // Story Script
  doc.addFileToVFS("StoryScript-Regular.ttf", StoryScriptRegular);
  doc.addFont("StoryScript-Regular.ttf", "StoryScript", "normal");
  
   // Arizonia-Regular
  doc.addFileToVFS("Arizonia-Regular.ttf", ArizoniaRegular);
  doc.addFont("Arizonia-Regular.ttf", "ArizoniaRegular", "normal");
  
  // MountainsofChristmas-Regular
  doc.addFileToVFS("MountainsofChristmas-Regular.ttf", MountainsofChristmasRegular);
  doc.addFont("MountainsofChristmas-Regular.ttf", "MountainsofChristmasRegular", "normal");
  
  
  doc.addFileToVFS("Qwigley-Regular.ttf", QwigleyRegular);
  doc.addFont("Qwigley-Regular.ttf", "QwigleyRegular", "normal");
  
  doc.addFileToVFS("Niconne-Regular.ttf", NiconneRegular);
  doc.addFont("Niconne-Regular.ttf", "NiconneRegular", "normal");
  
  doc.addFileToVFS("Calligraffitti-Regular.ttf", CalligraffittiRegular);
  doc.addFont("Calligraffitti-Regular.ttf", "CalligraffittiRegular", "normal");
  
  doc.addFileToVFS("Norican-Regular.ttf", NoricanRegular);
  doc.addFont("Norican-Regular.ttf", "NoricanRegular", "normal");
  
  doc.addFileToVFS("OoohBaby-Regular.ttf", OoohBabyRegular);
  doc.addFont("OoohBaby-Regular.ttf", "OoohBabyRegular", "normal");
  
  
  doc.addFileToVFS("Playball-Regular.ttf", PlayballRegular);
  doc.addFont("Playball-Regular.ttf", "PlayballRegular", "normal");
  
  doc.addFileToVFS("Cookie-Regular.ttf", CookieRegular);
  doc.addFont("Cookie-Regular.ttf", "CookieRegular", "normal");
  
  
}
